export const isAlreadyVisiting = (pathname, subjectPath) => {
  return pathname.includes(subjectPath);
};
